import { Body1 } from "@material/react-typography";
import React from "react";
import "./RoleTitleRow.scss";
import classNames from "classnames";

import { RoleAssignment } from "~/roles/types";

type RoleTitleRowProps = {
  role: RoleAssignment;
  setRoleAssignment: React.Dispatch<RoleAssignment | null>;
  selected: boolean;
};

export const RoleTitleRow: React.FC<RoleTitleRowProps> = ({
  role,
  setRoleAssignment,
  selected,
}) => {
  const { roleName, employees } = role;

  // added title attribute to make element selection during testing easier
  return (
    <div
      onClick={() => setRoleAssignment(role)}
      className={classNames({ selected }, "role-title-row")}
      title={roleName}
    >
      <div className="role-title">
        <Body1>
          {roleName}

          <span>({employees.length})</span>
        </Body1>
      </div>
    </div>
  );
};
